export default {
  nombre: "Nombre",
  id: "Id",
  "no-results": "No hay resultados para la búsqueda",
  cada: "Cada",
  minutos: "minutos",
  horas: "horas",
  codigo:"codigo",
  cron: "Periodicidad",
  iniciar: "Iniciar",
  detener: "Detener",
  buscar:"Buscar",
  "en-ejecucion": "En ejecución",
  "repetir-clave": "Repetir clave",
  "cambiar-clave": "Cambiar clave",
  abrirficha: "Abrir ficha",
  seguimiento: "Seguimiento",
  cita: "Cita",
  iniconsulta: "Iniciar consulta",
  dynamically_form: {
    regclonado: "Registro clonado. Ahora editelo. Recuerde cambiar el código",
    regguardado: "Guardado.",
    regactualizado: "Actualizado.",
    regnosepuedeguardar: "No se ha podido guardar, compruebe los campos.",
  },
  mensajes: {
    "save-ok": "Cambios realizados correctamente",
    confirmar: "Confirmación",
    "pregunta-borrar": '¿ Está seguro que quiere eliminar "',
    ok: "Correcto",
  },
  general: {
    DEEditGridTexts: {
      confirmDeleteMessage: null,
      deleteRow: "Borrar",
      editRow: "Editar",
      saveRowChanges: "",
      cancelRowChanges: "",
    },
    DEEditGroupTexts: "Arrastrar cabecera de columna aquí para agrupar.",
    DEEditSearchTexts: "Buscar",
    DEEditNoDataTexts: "No hay datos que mostrar",
  },
  api: {
    OK: "La solicitud ha tenido éxito",
    CREATED:
      "La solicitud ha tenido éxito y ha llevado a la creación de un recurso",
    NO_CONTENT:
      "La petición se ha completado con éxito pero su respuesta no tiene ningún contenido",
    BAD_REQUEST: "El servidor no ha podido procesar la petición",
    UNAUTHORIZED: "Es necesario autenticar",
    FORBIDDEN: "No se poseen los permisos necesarios",
    NOT_FOUND: "Página no encontrada",
    METHOD_NOT_ALLOWED: "No se admite el método HTTP solicitado",
    NOT_ACCEPTABLE: "No se admite el formato solicitado",
    CONFLICT: "Se ha producido un conflicto con el estado actual del servidor",
    UNSUPPORTED_MEDIA_TYPE:
      "El formato multimedia no está soportada por el servidor",
    INTERNAL_SERVER_ERROR: "Error interno del servidor",
  },
};
